import type { AssessmentTest } from '@ts-assessment/interfaces'

import { questions as questionsMath } from '@config/assessment/questions/math/grade-k2'
import { questions as questionsEla } from '@config/assessment/questions/ela/grade-k2'
import { questionsTest as questionsElaTest } from '@config/assessment/questions/ela/grade-k2-test'

export const configK2: AssessmentTest = {
  title: 'Grade 2 math assessment',
  quizTitle: 'Math assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Math check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsMath,
}
export const configK2Ela: AssessmentTest = {
  title: 'Grade 2<br> reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsEla,
}

export const configK2ElaTest: AssessmentTest = {
  title: 'Grade 2<br> reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsElaTest,
}
